
import { useState, useContext, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import ApiContext from 'src/provider/API/call-service';
import AppInfoContext from 'src/provider/state-manager/appInfoProvider';
import utility from 'src/utils/utility'
import { CustomContainer, ScreenContainer } from 'src/style';
import { ReportFilter, ServerSideTable } from 'src/component';
import helpers from 'src/utils/helpers';
import { accountOpeningRequestColumn, accountUpgradeRequestColumn, accountUpgradeRequestData } from 'src/utils/tableLayout';
import {useTranslation} from 'react-i18next';

const NonNigerianAccountOpeningRequest = () => {
    const navigate = useNavigate()
    const {API, downloadReport} = useContext(ApiContext)
    const {info: {selectedAccountUpgradeRequest}, setInfoProperty} = useContext(AppInfoContext)
    const [requestsData, setRequestsData] = useState<any>(null)
    const [requests, setRequests] = useState<any>(null)
    const [showFilter, setShowFilter] = useState<boolean>(false)
    const [resetPagination, setResetPagination] = useState<boolean>(false)
    const { t } = useTranslation()

    const filterDataRef = useRef({})
    
    useEffect(() => {
        filterDataRef.current = {}
        handleFetchRequests()
    }, [])

    async function handleFetchRequests (pageNumber = 1, pageLimit = 10, isDownload = false) {
        const response = await API.getAccountOpeningRequests(pageNumber, pageLimit, {...filterDataRef.current, returnMax: isDownload})
        console.log("rrere", filterDataRef?.current)
        if (response) {
            if (isDownload) {
                return downloadReport(response, t('customer.nonNigerianAccount.downloadFileName'))
            }
            setRequestsData(response)
            setRequests(helpers.addSerialNumberToItems(response?.data, response.meta))
        }
    }

    function handleClear () {
        filterDataRef.current = {}
        handleFetchRequests()
        setResetPagination(!resetPagination)
    }

    async function handleViewDetails (data: any) {
        await setInfoProperty('selectedAccountOpeningRequest', data)
        navigate(`/dashboard/non-nigerian-account-opening-details`)
    }

    return (
        <>
            <ScreenContainer>
                <CustomContainer topMargin='3'>
                    <ServerSideTable
                        tableData={requests}
                        tableColumns={accountOpeningRequestColumn(handleViewDetails,t )} 
                        dataFetchMethod={handleFetchRequests}
                        totalRows={requestsData?.meta?.total}
                        tableTitle={t('customer.upgrade.tableTitle')}
                        customStyle
                        shouldResetPagination={resetPagination}
                        //canSearch
                        canFilter={() => setShowFilter(true)}
                        canClear={handleClear}
                        downloadAction={() => handleFetchRequests(1, 10, true)}
                    />
                </CustomContainer>
            </ScreenContainer>
            { showFilter &&
                <ReportFilter
                    type='account-request'
                    onApplyFilter={handleFetchRequests}
                    setFilterData={(data: any) => {filterDataRef.current = data}}
                    close={() => setShowFilter(false)} 
                />
            }
        </>
    )
}

export default utility.routeData('non-nigerian-account-request', 'Non Nigerian Account Opening Requests', <NonNigerianAccountOpeningRequest/>)